import AuthService from '../../service';
const FaqCategory = {
  getFaqCategory(page,search){
    return AuthService.get(`faq/faq_category?page=${page}&search=${search}`);
  },
  showFaqCategory(id){
    return AuthService.get(`faq/faq_category/${id}`);
  },
  createFaqCategory(data){
    return AuthService.post(`faq/faq_category`,data);
  },
  updateFaqCategory(id,data){
    return AuthService.put(`faq/faq_category/${id}`,data);
  },
  deleteFaqCategory(id){
    return AuthService.delete(`faq/faq_category/${id}`);
  },
  getFaqCategoryAll(){
    return AuthService.get(`faq/faq_category_all`);
  }
}
export default FaqCategory
